export default __webpack_public_path__ + "static/media/8-16-09-bowie.56d6eeee.m4a";